import { useCallback, useContext } from "react";

import { BaseModal } from "./BaseModal";
import { PlayerContext } from "../contexts/PlayerContext";
import { HouseContext } from "../contexts/HouseContext";
import { TermsAndConditionsStep } from "./registration/TermsAndConditions";

interface ITermsAndConditionsModal {
  open: boolean;
  handleClose: Function;
}

export const TermsAndConditionsModal = ({ open, handleClose }: ITermsAndConditionsModal) => {
  const { playerMeta, setPlayerMeta } = useContext(PlayerContext);
  const { house } = useContext(HouseContext);

  const setLatestTerms = useCallback(() => {
    if (house == null) {
      return;
    }

    const meta = playerMeta || {};
    meta.latestHouseTerms = house.latestTermsVersion;
    meta.latestPlatformTerms = 0;
    meta.signedTerms = true;

    setPlayerMeta(meta);
    handleClose();
  }, [playerMeta, house, handleClose]);

  return (
    <BaseModal open={open} hideModal={handleClose}>
      <div className="flex flex-col w-[80vw] md:w-[560px]">
        <TermsAndConditionsStep setLatestTermsVersion={setLatestTerms} onClose={handleClose} />
      </div>
    </BaseModal>
  );
};
